import { Component, ViewChild, ElementRef, ChangeDetectorRef, OnInit, EventEmitter, Output } from '@angular/core';
import { MapService } from '../../../map.service';
import { MapElement } from '../../../map-element.model';
import { Point } from 'geojson';

@Component({
  selector: 'qm-mapbox',
  templateUrl: './mapbox.component.html',
  styleUrls: ['./mapbox.component.scss']
})
export class MapboxComponent implements OnInit {
  @Output() mapReady = new EventEmitter(false);
  @ViewChild('mapbox', {static: true}) public mapElement: ElementRef;

  public markers: MapElement<Point>[];

  constructor(
    private mapService: MapService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.mapService.initMap(this.mapElement.nativeElement);
    this.mapReady.next(true);

    this.mapService.visibleMarkers$.subscribe(markers => {
      this.markers = markers;
      this.cdr.markForCheck();
    });
  }

  public trackByFn(index, item) {
    return item.id;
  }
}
